import React, { useState, useEffect, useRef } from 'react';
import { secToClock } from './timeUtils';

/**
 * 実行中タスクのタイマー。
 * このコンポーネントだけが更新されるので、他の部分は再描画されません。
 *
 * 表示ルール:
 *   残り > 0 のあいだ   … ceil(残り秒) を表示（30:00 → … → 00:01）
 *   残り <= 0 になったら … その瞬間に赤くなり +00:00 → +00:01 → …
 * これで「30:00 から赤くなるまで」がちょうど30分になります。
 */
function TimerDisplay({ startedAt, estimatedMinutes }) {
  const [, forceRender] = useState(0);
  const ref = useRef(null);
  const wasOver = useRef(null);

  useEffect(() => {
    // 秒の境目をまたいだ瞬間に切り替わるよう、細かめに刻む
    const id = setInterval(() => forceRender((n) => n + 1), 250);
    return () => clearInterval(id);
  }, []);

  const elapsedMs = startedAt ? Date.now() - new Date(startedAt).getTime() : 0;
  const noEstimate = estimatedMinutes === null || estimatedMinutes === undefined;

  let text;
  let isOver = false;

  if (noEstimate) {
    // 見積なし: 経過時間をカウントアップ（00:00 から）
    text = secToClock(Math.floor(elapsedMs / 1000));
  } else {
    const remainingMs = estimatedMinutes * 60000 - elapsedMs;
    if (remainingMs > 0) {
      text = secToClock(Math.ceil(remainingMs / 1000));
    } else {
      isOver = true;
      text = `+${secToClock(Math.floor(-remainingMs / 1000))}`;
    }
  }

  // 親を再描画させずに行の色だけ切り替える
  useEffect(() => {
    if (wasOver.current === isOver) return;
    wasOver.current = isOver;
    const row = ref.current && ref.current.closest('.task-row');
    if (row) row.classList.toggle('over', isOver);
  });

  return (
    <div
      ref={ref}
      className={`row-timer ${isOver ? 'over' : ''} ${noEstimate ? 'plain' : ''}`}
    >
      {text}
    </div>
  );
}

export default TimerDisplay;
